import React, { useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { getParameterByName } from './js/params';
import Login from './components/Auth/Login';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import Disclaimer from './components/Disclaimer';
import Apps from './components/Apps';
import ScheduleFrame from './components/ScheduleFrame';
import FreeUtmAudit from './components/FreeUtmAudit';
import { Route, Routes, Switch } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setStoreData } from './store/auth';
import SignUp from './components/Auth/Signup';
import Layout from './components/Layout';
import PayFlow from './components/PayFlow';
import { useNavigate } from 'react-router-dom';
import AccountInfos from './components/AccountInfos';
import Home from './components/Home';
import ConfirmUser from './components/confirmUser';
import ForgotPassword from './components/ForgotPassword';
import Toast from './components/Toast';
import AreWeFit from './components/AreWeFit';
import Downloads from './components/AccountInfos/Downloads';
import Subscriptions from './components/AccountInfos/Subscriptions';
import Billings from './components/AccountInfos/Billings';
import MyAccounts from './components/AccountInfos/MyAccount/MyAccounts';
import Sites from './components/AccountInfos/Sites';
import NoMatch from './components/NoMatch';
import Chat from './components/Chat/Chat';
import SupportBought from './components/SupportBought';
import Welcome from './components/Welcome';
import UTM from './components/utm/Index';
const { $crisp } = window;

function App() {
  const dispatch = useDispatch();
  const {
    localPromoName,
    isAuthenticated,
    isAuthenticating,
    showForgotPassword,
    showPayment,
  } = useSelector((state) => state.auth.data || {});

  const navigate = useNavigate();

  const checkTimedPromo = () => {
    let promos = [
      // {coupon: '4Sa9VJy9', params:{utm_campaign: '20OFFPromo'}},
      // {coupon: '4Sa9VJy9', params:{gclid: null}},
      {
        coupon: '',
        params: { utm_campaign: '4WPCommunity' },
        multiplier: true,
      },
      {
        coupon: '',
        params: { utm_campaign: 'HelloTwitter' },
        multiplier: true,
      },
      { coupon: '', params: { utm_campaign: 'FB2X' }, multiplier: true },
      {
        coupon: 'AChtMnPH',
        params: { root: 'BF22' },
        multiplier: false,
        expire: 1669679940000,
      },
    ];

    let nowTime = new Date().getTime();
    let expireIfEmpty = new Date().getTime() + 4 * 60 * 60 * 1000;
    let expire, coupon, multiplier, promo;
    let localName = localPromoName;
    let promoPayload;

    //Clean the expired promos from local
    if (localStorage.getItem(localName)) {
      promoPayload = JSON.parse(localStorage.getItem(localName));
      expire = promoPayload.expire;
      coupon = promoPayload.coupon;
      multiplier = promoPayload.multiplier;
      promo = promoPayload.promo;
      if (expire < nowTime) {
        localStorage.removeItem(localName);
        expire = undefined;
      }
    }

    if (expire === undefined) {
      promos.some((param) => {
        const query_params = param.params;
        multiplier = param.multiplier ? param.multiplier : false;
        const key = Object.keys(query_params)[0];
        const value = query_params[key];
        let match = 0;
        if (value !== null && getParameterByName(key) === value) {
          match = 1;
          promo = value;
        } else if (value === null && getParameterByName(key)) {
          match = 1;
        } else if (key == 'root') {
          match = 1;
          promo = value;
        }

        if (match) {
          if ((param.expire && param.expire > nowTime) || !param.expire) {
            expire = param.expire ? param.expire : expireIfEmpty;
            coupon = param.coupon;
            return true;
          }
        }
      });
      //If yes, insert local
      if (expire !== undefined) {
        localStorage.setItem(
          localName,
          JSON.stringify({ expire, coupon, multiplier, promo })
        );
      }
    }

    if (expire !== undefined) {
      //this.updatePricesWithPromo(coupon)
      //var res = this.getProductPrice(coupon);
      //this.setState({'discount_applied': res ? res : -1})
      dispatch(setStoreData({ data: { multiplier } }));
      // setState({ ...state, multiplier: multiplier });
    }
  };

  // const updatePricesWithPromo = (coupon) => {
  //   let tmpPrices = prices;
  //   for (const planId in tmpPrices) {
  //     tmpPrices[planId]['stripe_coupon'] = coupon;
  //   }
  //   dispatch(setStoreData({ data: { prices: tmpPrices } }));
  //   // setState({ ...state, prices: prices });
  // };

  const CrispChatActive = () => {
    if (typeof window.HandL === 'object') {
      let params = window.HandL.getAll();
      Object.keys(params).forEach((k) => params[k] == null && delete params[k]);
      let crispData = [];
      Object.entries(params).forEach(([key, value]) => {
        crispData.push([key, value]);
      });
      $crisp.push(['set', 'session:data', [crispData]]);
    }
  };

  useEffect(() => {
    const startFunc = async () => {
      try {
        checkTimedPromo();
        // const session = await Auth.currentSession();
        dispatch(setStoreData({ data: { isAuthenticated: true } }));
        // setMainStates("isAuthenticated", true);
        if (localStorage.getItem('paidMethod')) {
          dispatch(
            setStoreData({
              data: {
                isSupportable: JSON.parse(
                  localStorage.getItem('isSupportable')
                ),
              },
            })
          );
          // setMainStates("isSupportable", localStorage.getItem("isSupportable"));
        }
        const user = await Auth.currentAuthenticatedUser();
        console.log('current authenticated: ', user);
        dispatch(
          setStoreData({
            data: {
              user,
              tmpUser: {
                first_name: user.attributes.given_name,
                email: user.attributes.email,
              },
            },
          })
        );

        $crisp.push(['set', 'user:nickname', [user.attributes.given_name]]);
        $crisp.push(['set', 'user:email', [user.attributes.email]]);
      } catch (error) {
        let tmpUser = localStorage.getItem('tmpUser');
        if (tmpUser) {
          dispatch(
            setStoreData({
              data: {
                tmpUser: JSON.parse(tmpUser),
                isAuthenticated: true,
              },
            })
          );
        } else {
          dispatch(
            setStoreData({
              data: {
                isAuthenticated: false,
              },
            })
          );
        }
        console.log('error: ', error);
      }

      if (getParameterByName('login') === '1' && !isAuthenticated) {
        dispatch(
          setStoreData({
            data: {
              showLogin: true,
            },
          })
        );
      }
      if (getParameterByName('forgotPassword') === '1') {
        dispatch(
          setStoreData({
            data: {
              showForgotPassword: true,
            },
          })
        );
      }

      if (getParameterByName('thanks') === '1') {
        // dispatch(
        //   setStoreData({
        //     data: {
        //       showThanks: true,
        //     },
        //   })
        // );
        navigate('/payment' + window.location.search);
      }

      if (getParameterByName('EarlyAccessDiscount') === '1') {
        dispatch(
          setStoreData({
            data: {
              earlyAccessDiscount: true,
            },
          })
        );
      }

      // if ( getParameterByName('code') && getParameterByName('scope')){
      if (getParameterByName('scope')) {
        dispatch(
          setStoreData({
            data: {
              showApps: true,
            },
          })
        );
      }
      dispatch(
        setStoreData({
          data: {
            isAuthenticating: false,
          },
        })
      );

      $crisp.push(['on', 'chat:initiated', CrispChatActive]);
      $crisp.push(['on', 'message:sent', CrispChatActive]);
    };
    startFunc();
  }, []);

  return (
    <Layout>
      <Login />
      <SignUp />
      <AreWeFit />
      {getParameterByName('confirmation_code') !== '' && <ConfirmUser />}
      {!isAuthenticating && (
        <Routes>
          {/* <Switch> */}
          <Route path='/' element={<Home />} />
          <Route path='terms' element={<Terms />} />
          <Route path='privacy' element={<Privacy />} />
          <Route path='disclaimer' element={<Disclaimer />} />
          <Route path='payment' element={<PayFlow />} />
          <Route path='support/welcome' element={<SupportBought />} />
          <Route path='welcome' element={<Welcome />} />
          {/* <Route path="/license" element={<LicenseKey />} /> */}
          {/* <Route path="/myaccount" element={<MyAccount />} /> */}
          <Route path='infos' element={<AccountInfos />}>
            <Route index element={<Downloads />} />
            <Route path='downloads' element={<Downloads />} />
            <Route path='subscriptions' element={<Subscriptions />} />
            <Route path='billings' element={<Billings />} />
            <Route path='myaccounts' element={<MyAccounts />} />
            <Route path='sites' element={<Sites />} />
            <Route path='chat' element={<Chat />} />
            <Route path='*' element={<NoMatch />} />
          </Route>
          <Route path='schedule' element={<ScheduleFrame />} />
          <Route path='utm' element={<UTM />} />
          <Route path='free-utm-audit' element={<FreeUtmAudit />} />
          <Route path='apps' element={<Apps />} />
          <Route path='*' element={<NoMatch />} />
          {/* </Switch> */}
        </Routes>
      )}
      <ForgotPassword />
      <div className='hidden lg:block md:block'>
        <Toast />
      </div>
    </Layout>
  );
}

export default App;
